exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-addon {\n    color: rgba(153, 153, 153, 0.44);\n}\n\n.form-control::-webkit-input-placeholder {\n    color: rgba(153, 153, 153, 0.44);\n}\n\n/* WebKit, Blink, Edge */\n\n.form-control:-moz-placeholder {\n    color: rgba(153, 153, 153, 0.44);\n}\n\n/* Mozilla Firefox 4 to 18 */\n\n.form-control::-moz-placeholder {\n    color: rgba(153, 153, 153, 0.44);\n}\n\n/* Mozilla Firefox 19+ */\n\n.form-control:-ms-input-placeholder {\n    color: rgba(153, 153, 153, 0.44);\n}\n\n/* Internet Explorer 10-11 */\n\n.form-control::-ms-input-placeholder {\n    color: rgba(153, 153, 153, 0.44);\n}\n\n.input-group {\n    width: 100%;\n}\n\ninput {\n    color: rgba(153, 153, 153, 0.99);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src185846418/src/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main